import { PartFinderReport } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError } from '@/types/apiError';
import { Query, useQuery } from '@tanstack/react-query';

export const PART_FINDER_REPORT_QUERY_KEY = 'partFinderReport';

export const useGetPartFinderReport = (
  id: string,
  options?: {
    refetchInterval?: number | false | ((query: Query<PartFinderReport, AxiosApiError>) => number | false);
  }
) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useQuery<PartFinderReport, AxiosApiError>({
    queryKey: [PART_FINDER_REPORT_QUERY_KEY, id],
    queryFn: async () => {
      const response = await api.tenants.getPartFinderReport(tenantId, id);
      return response.data.partFinderReport;
    },
    enabled: !!id && !!tenantId,
    refetchInterval: options?.refetchInterval,
  });
};
